import { Navigate, Route, Routes } from 'react-router-dom'
import { WeddingTypesListPage } from './taskNotifications/WeddingTypesListPage'
import { TaskListTasksPage } from './taskNotifications/TaskListTasksPage'
import { DefaultTasksPage } from './taskNotifications/DefaultTasksPage'

export function WeddingTasksConfigPanel() {
	return (
		<Routes>
			<Route path="wedding-tasks" element={<WeddingTypesListPage />} />
			<Route
				path="wedding-tasks/list/:taskListKey"
				element={<TaskListTasksPage />}
			/>
			<Route path="wedding-tasks/defaults" element={<DefaultTasksPage />} />
			<Route
				path="*"
				element={<Navigate to="/admin/configs/wedding-tasks" replace />}
			/>
		</Routes>
	)
}
